<template>
  <div>
    <tablemx :data="tableData" />
    <el-pagination
      background
      hide-on-single-page
      :current-page="querInfo.pagenum"
      :page-sizes="[20, 30, 50, 100]"
      :page-size="querInfo.pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="querInfo.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { getBillDetail } from '@/api/bill/index'
import tablemx from './table-mx'
export default {
  components: {
    tablemx
  },
  props: {
    data: {
      type: Object,
      default: () => []
    },
    this: {
      type: Object,
      default: () => []
    }
  },
  data() {
    return {
      tableData: [],
      querInfo: {
        pagenum: 1,
        pagesize: 20,
        total: 0
      }
    }
  },
  watch: {
    data(n) {
      this.data = n
    },
    this(n) {
      this.this = n
    },
    deep: true
  },
  created() {
    console.log(this.this.$list.vm.$search.vm.data)
    this.getInfo()
  },
  methods: {
    async getInfo() {
      const data = {
        'condition': {
          ...this.this.$list.vm.$search.vm.data,
          'sourceSeq': this.data.sourceSeq,
          'supplierName': this.data.supplierNo,
          'goodsNo': this.data.goodsNo,
          'purchaseNo': this.data.purchaseNo,
          'asnNo': this.data.asnNo
        },
        'current': this.querInfo.pagenum,
        'size': this.querInfo.pagesize
      }
      console.log(data)
      const info = await getBillDetail(data)
      this.tableData = info.records
      this.querInfo.total = info.total
    },
    handleSizeChange(val) {
      this.querInfo.pagesize = val
      this.getInfo()
    },
    handleCurrentChange(val) {
      this.querInfo.pagenum = val
      this.getInfo()
    }
  }
}
</script>

<style>
</style>
